module.exports = __webpack_public_path__ + "static/hero@2x-67ce2c0db7d585a462582dfb8de41629.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/agencies-industry-pages/hero@2x.jpg
// module id = 2530
// module chunks = 281026976107462